import React, { RefObject } from 'react';
import AttachmentsComponent from '@teetsh/app/src/components/Attachments/ButtonAttachment';
import { useUpdateCJEventAttachment } from 'containers/CahierJournal/queries/useUploadCJEventAttachment';
import useNotification from '@teetsh/app/src/containers/App/Notifications/useNotification';
import { PaperClipIcon as PaperClip } from '@heroicons/react/24/outline';
import { useField } from 'react-final-form';
import { useTranslation } from 'react-i18next';

interface Props {
  formFieldName: string;
  inputRef?: RefObject<HTMLInputElement>;
  onAddToSeanceCallback?: () => void;
}

export function AttachmentButton(props: Props) {
  const { formFieldName, inputRef, onAddToSeanceCallback } = props;
  const { upload, isUploading } = useUpdateCJEventAttachment();
  const { notifyError } = useNotification();
  const attachmentsField = useField(formFieldName);
  const { t } = useTranslation(['cahierJournal']);
  return (
    <AttachmentsComponent
      onChange={attachmentsField.input.onChange}
      attachments={attachmentsField.input.value}
      label={t('cahierJournal:seance.modal.attachment')}
      alignText="left"
      uploadingAttachment={isUploading}
      handleError={({ message }) => {
        notifyError({
          title: message,
        });
      }}
      multiple
      small
      icon={PaperClip}
      handleUploadAttachment={({ file }) =>
        upload({ file })
          .then(v => {
            inputRef?.current?.focus();
            onAddToSeanceCallback?.();
            return v;
          })
          .catch(err => {
            notifyError({
              title: t(
                'cahierJournal:messages.successfullyCopied.attachmentUploadFail',
              ),
            });
            throw new Error(err);
          })
      }
    />
  );
}
